module.exports = __webpack_public_path__ + "img/real_time_off.f6ebf183.svg";